export default __webpack_public_path__ + "static/media/bg.37d5f90a.jpg";